import { AppBar, Box, ImageList, Toolbar, Typography } from '@mui/material';
import React, { useContext, useState, useCallback } from 'react';
import headerStyles from '../../../menu/trackfavmenu.module.css';
import styles from '../../infoblock.module.css';
import AppContext from '../../../context/AppContext';
import { ReactComponent as BackIcon } from '../../../assets/icons/ic_arrow_back.svg';
import ImageItem from '../../../menu/search/explore/ImageItem';
import IconBtn from '../../../frame/components/btns/IconBtn';

export default function WptPhotoList({ photos }) {
    const ctx = useContext(AppContext);
    const [loadedImages, setLoadedImages] = useState({});

    const handleImageLoad = useCallback((index) => {
        setLoadedImages((prevState) => ({
            ...prevState,
            [index]: true,
        }));
    }, []);

    return (
        <Box minWidth={ctx.infoBlockWidth} maxWidth={ctx.infoBlockWidth} sx={{ height: 'auto', overflowX: 'hidden' }}>
            <AppBar position="sticky" sx={{ top: 0, width: '100%' }} className={headerStyles.appbar}>
                <Toolbar className={headerStyles.toolbar}>
                    <IconBtn
                        variant="contained"
                        type="button"
                        className={styles.closeIcon}
                        onClick={() => ctx.setPhotoGallery(null)}
                    >
                        <BackIcon />
                    </IconBtn>
                    <Typography component="div" className={headerStyles.title}>
                        Photos
                    </Typography>
                </Toolbar>
            </AppBar>
            <ImageList sx={{ pr: '16px', pl: '16px', overflowX: 'hidden' }} gap={16} cols={2}>
                {photos.map((photo, index) => (
                    <ImageItem
                        key={index}
                        photo={photo}
                        index={index}
                        handleImageLoad={handleImageLoad}
                        isLoaded={!!loadedImages[index]}
                    />
                ))}
            </ImageList>
        </Box>
    );
}
